import {
  Box,
  Button,
  Card,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import { configs } from "@/configs";
import { formatTimeRange } from "@/formatter";
import { theme } from "@/theme";

import type { MouseEventHandler } from "react";
import type { Facility } from "@/models";

export type FacilityCardProps = {
  data: Facility;
  branchId: number;
};

export function FacilityCard({ data, branchId }: FacilityCardProps) {
  const { id, name, thumbnailUrl, openedAt, closedAt } = data;
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const onClick: MouseEventHandler<HTMLButtonElement> = () =>
    navigate(`${id.toString()}?branchId=${branchId}`);

  const buttonSize = isMobile ? "small" : "medium";

  return (
    <Card sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Box
        width="100%"
        pt="66.66%"
        sx={{
          backgroundImage: `url(${thumbnailUrl ?? configs.defaultImageURL})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <Stack px={2} pt={2}>
        <Typography
          gutterBottom
          sx={{
            typography: { xs: "subtitle2", sm: "h6" },
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            width: "100%",
          }}
        >
          {name}
        </Typography>
        <Typography
          color="text.disabled"
          mb={2}
          sx={{ typography: { xs: "caption", sm: "body2" } }}
        >
          เวลาให้บริการ : {formatTimeRange(openedAt, closedAt)} น.
        </Typography>
      </Stack>
      <Box mt="auto" px={2} pb={2}>
        <Button
          size={buttonSize}
          variant="contained"
          fullWidth
          onClick={onClick}
        >
          รายละเอียด
        </Button>
      </Box>
    </Card>
  );
}
